import { render } from "./FrameNav.vue?vue&type=template&id=5841b2c3&scoped=true"
import script from "./FrameNav.vue?vue&type=script&lang=js"
export * from "./FrameNav.vue?vue&type=script&lang=js"

import "./FrameNav.vue?vue&type=style&index=0&id=5841b2c3&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5841b2c3"]])

export default __exports__